import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useAdminEvents — Fetches events for admin management.
 *
 * API: GET /api/admin/events → AdminEventDto[] (CON-002 §9)
 * Requires Bearer token (authed fetcher, DEF-010). Defaults to future events
 * only (backend `includePast=false`).
 *
 * @returns {{ events: Array, error: any, isLoading: boolean, mutate: Function }}
 */
export function useAdminEvents() {
  const { data, error, isLoading, mutate } = useSWR(
    API.ADMIN.EVENTS.LIST,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { events: data ?? [], error, isLoading, mutate };
}

/**
 * invalidateAdminEvents — Force-revalidates the admin events SWR cache.
 * @returns {Promise<any>}
 */
export const invalidateAdminEvents = () =>
  globalMutate(API.ADMIN.EVENTS.LIST);
